import React, {useContext, useEffect, useState} from 'react'
import BackButton from '../../Common/BackButton'
import SearchButton from '../../Common/SearchButton'
import AppButton from '../../Common/AppButton'
import SearchResults from '../../SearchResults'
import RequiredInfo from '../../Common/RequiredInfo'
import Loading from '../../Loading'
import {Grid} from '@material-ui/core'
import useStyles from "./styles";
import ClearIcon from '@material-ui/icons/Clear'

import {useParams} from "react-router";

import messages from "./messages";
import AppContext from '../../../contexts/App/App.context'
import {apiStatus} from "../../../shared/enums";
import PriorAuthorizationContext from "../../../contexts/PriorAuthorization/PriorAuthorization.context";
import UniversalSearch from './UniversalSearch'
import ConfirmationModal from '../../Common/ConfirmationModal';

export default function SearchView(){

    const {operation} = useParams();
    const classes = useStyles()
    const { universalVerbiage } = messages;
    const { title } = messages[operation];
    const context = useContext(PriorAuthorizationContext);
    const { setOperation, authNumber, setAuthNumber, fields, status, resetFields, inquiry: {getRecords, data, clearData } } = context
    const { npiNumber, provider: {providerType} } = useContext(AppContext);
    const [hasFormError, setFormError] = useState(true)
    const [modal, setModal] = useState({open: false, title: ''})

    const universal = authNumber ? false : true
    const hasBeneficiaryInfo = fields.beneficiaryDOB.value
                                || fields.beneficiaryID.value
                                || fields.beneficiaryLastName.value
                                || authNumber
    const paInfoPayload = { npi: npiNumber,
                            operation,
                            authNumber,
                            beneficiaryDOB: fields.beneficiaryDOB.value,
                            beneficiaryID: fields.beneficiaryID.value,
                            beneficiaryLastName: fields.beneficiaryLastName.value,
                            advancedSearch: universal,
                            startDate: universal ? window.moment(fields.requestBeginDate.value).format('MM/DD/YYYY') : '',
                            endDate: universal ? window.moment(fields.requestEndDate.value).format('MM/DD/YYYY') : '',
                            providerType
                        }

    const clearBeneficiaryInfo = () => {
        setAuthNumber('')
        resetFields(['beneficiaryDOB', 'beneficiaryID','beneficiaryLastName'])
    }

    const handleSearch = () => {
        getRecords(paInfoPayload)
    }

    useEffect(()=>{
        setOperation(operation, authNumber)

        if(data){
            getRecords(paInfoPayload)

        }
    // eslint-disable-next-line
    }, [])

    // Clear data when search critera is updated
    useEffect(() => {

        if(data){
            clearData()
        }

        // eslint-disable-next-line
    }, [context.fields, authNumber])


    return(
        <div id='MEDCAL_RX_INQUIRY_FLOW_SCREEN' style={{width: '100%'}}>
            { status === apiStatus.LOADING &&
                <Loading />
            }
            <Grid container spacing={2}>

                {/* Action Bar */}
                <Grid className={classes.backBar} container alignItems='center' spacing={0} item xs={12}>
                    <Grid item xs={2}>
                        <BackButton />
                    </Grid>
                </Grid>

                {/* Title Bar */}
                <Grid container spacing={0} item xs={12} >
                    <Grid item xs={8} sm={6} md={5} >
                        <div className={classes.pageHeader} id={title.id}>
                            <h1>{title.text}</h1>
                        </div>
                    </Grid>
                    {/* Advanced Search Message */}
                    { operation === 'inquiry' &&
                        <Grid container item>
                            <Grid item xs={12} className={classes.universalVerbiage}>
                                {universalVerbiage}
                            </Grid>
                            <Grid item xs={12} className={classes.formVerbiage}>
                                Please enter Authorization Number if available.
                                Else enter only Beneficiary ID OR both Beneficiary DOB and Beneficiary Last Name
                            </Grid>
                        </Grid>
                    }
                </Grid>

                {/* Form Area */}
                <div className={classes.formWrapper}>

                    <Grid container spacing={1} item xs={12}>

                        {/* Universal Search Componenet */}
                        <Grid item xs={8}>
                            <div id='MEDCAL_RX_REQUIRED_INFO_LABEL'>
                                <RequiredInfo className={classes.requiredInfo} />
                            </div>
                            <UniversalSearch
                                operation={operation}
                                context={context}
                                setFormError={setFormError}
                            />
                        </Grid>

                        {/* Search Options */}
                        <Grid
                            id='MEDCAL_RX_SEARCH_BUTTON_CONTAINER'
                            container justify='center' alignItems='center'
                            item xs={8}
                            style={{paddingLeft: '5vw', paddingTop: '5vh'}}
                        >
                            <AppButton
                                text='Clear'
                                variant='outlined'
                                icon={<ClearIcon />}
                                size='large'
                                style={{margin: '1.3rem'}}
                                disabled={!hasBeneficiaryInfo}
                                onClick={clearBeneficiaryInfo}
                                buttonStyle={{minWidth: '135px', maxWidth: '135px'}}
                            />
                            <SearchButton
                                disabled={ hasFormError }
                                size='large'
                                onClick={handleSearch}
                            />
                        </Grid>
                    </Grid>
                </div>

                { status === apiStatus.SUCCESS && !hasFormError && data &&
                    <Grid item xs={12}>
                        <ConfirmationModal
                            confirm={() => setModal( prev => ({...prev, open: false}))}
                            confirmText='Close'
                            open={modal.open}
                            title={modal.title}
                            dialogTitle=''
                            isWarning={false}
                        />
                        <div id='MEDCAL_RX_PA_RESULTS_TABLE'  data-testid='inquiryResults'>
                                <div className={classes.inquiryResultsTable}>
                                    <SearchResults
                                        setModal={setModal}
                                        operationType={operation}
                                        data={data}
                                    />
                                </div>
                        </div>
                    </Grid>
                }
            </Grid>
        </div>
    )
}
